import { Eye } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Button } from "src/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "src/components/ui/drawer";
import { useLanguage } from "src/context/LanguageContext";
import QuestionCard from "../../../../../components/Quiz/question-card";
import { AnimatePresence, motion } from "framer-motion";
import { SubLessonData } from "../../../../../lib/languages";
import axios from "axios";
import { BaseUrlApi, ErrorMessage } from "../../../../../lib/api";
import { toast } from "sonner";
import { DrawerClose } from "../../../../../components/ui/drawer";

const DrawerQuizShowAnswer = ({ quizData, getAllAttemptQuiz }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(0);
  console.log(data);
  const handleEditWrittenScore = async () => {
    if (data?.answer_bid) {
      try {
        await axios.post(`${BaseUrlApi}/quizzes/evaluate/${data?.answer_bid}`, {
          score: data?.score,
        });
        toast("Score Updated", {
          description: "The score details have been successfully updated ✏️",
        });
      } catch (error) {
        toast("Error", {
          description: ErrorMessage(error),
        });
      }
    } else {
      toast.error("No Answer ID");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (data) {
        handleEditWrittenScore();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [data]);

  return (
    <Drawer
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        !value && getAllAttemptQuiz();
      }}
    >
      <DrawerTrigger asChild>
        <Button size="icon" className="rounded-xl h-9">
          <Eye />
        </Button>
      </DrawerTrigger>
      <DrawerContent dir={language === "ar" ? "rtl" : "ltr"}>
        <div className="h-[calc(100vh-2rem)] max-w-7xl w-full mx-auto overflow-auto hide-scrollbar">
          <DrawerHeader className="flex items-center justify-between flex-wrap gap-4">
            <div className="w-full sm:w-fit">
              <p className="font-bold text-2xl pt-5" id="category">
                {t.quizAnswersTitle} “{quizData?.user.name || "---"}”
              </p>
              <p className="font-medium text-sm">{t.reviewTestForStudent}</p>
            </div>
            <div className="flex items-center gap-2 w-full sm:w-fit">
              <DrawerClose asChild>
                <Button
                  variant="outline"
                  className="w-full sm:w-fit h-10 rounded-xl border-2 border-blue-600 text-blue-600 hover:text-blue-500"
                >
                  {t.close}
                </Button>
              </DrawerClose>
            </div>
          </DrawerHeader>
          <div className="p-4">
            <AnimatePresence>
              {quizData.quiz.questions.map((question, index) => {
                const selectedOption = question.options.find(
                  (option) => option.student_select
                );
                return (
                  <motion.div
                    key={question.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    className="mb-4"
                  >
                    <QuestionCard
                      question={question}
                      selectedAnswer={selectedOption?.id}
                      isEditMode={false}
                      isShowMode={true}
                      showCorrectAnswers={true}
                      language={language}
                      updateQuestion={(updatedQuestion) => {
                        setData(updatedQuestion);
                      }}
                      removeQuestion={() => {}}
                      onAnswerSelect={(optionId) => {}}
                    />
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerQuizShowAnswer;
